function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img-footer-line-old_svg__clip0_2428_91666)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-60.414 135.807C-159.384 149.607-208 111.268-208 111.268v462.539h1452.5L1232 37.882S1101.24-11.295 995.247 3.62c-105.988 14.915-181.338 61.928-282.02 55.46C612.546 52.614 493.663 8.463 349.5 18.946 205.337 29.428 176 51 91.126 86.046 27.632 112.266-8.44 128.56-60.414 135.808z",
  fill: "#fff",
  stroke: "#489F9D",
  strokeWidth: 3
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img-footer-line-old_svg__clip0_2428_91666"
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(-208 .804)",
  d: "M0 0h1440v138H0z"
})));

function SvgImgFooterLineOld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgdmlld0JveD0iMCAwIDEwMjQgMTM5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yNDI4XzkxNjY2KSI+CiAgICA8cGF0aCBkPSJNLTYwLjQxMzggMTM1LjgwN0MtMTU5LjM4NCAxNDkuNjA3IC0yMDggMTExLjI2OCAtMjA4IDExMS4yNjhWNTczLjgwN0gxMjQ0LjVMMTIzMiAzNy44ODE3QzEyMzIgMzcuODgxNyAxMTAxLjI0IC0xMS4yOTUgOTk1LjI0NyAzLjYyMDU2Qzg4OS4yNTkgMTguNTM2MSA4MTMuOTA5IDY1LjU0OTEgNzEzLjIyNyA1OS4wODE0QzYxMi41NDYgNTIuNjEzNyA0OTMuNjYzIDguNDYyODcgMzQ5LjUgMTguOTQ1NkMyMDUuMzM3IDI5LjQyODQgMTc2IDUxLjAwMDkgOTEuMTI2NSA4Ni4wNDY4QzI3LjYzMjUgMTEyLjI2NSAtOC40NDEwNiAxMjguNTYgLTYwLjQxMzggMTM1LjgwN1oiIGZpbGw9IndoaXRlIiBzdHJva2U9IiM0ODlGOUQiIHN0cm9rZS13aWR0aD0iMyIvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfMjQyOF85MTY2NiI+CiAgICAgIDxyZWN0IHdpZHRoPSIxNDQwIiBoZWlnaHQ9IjEzOCIgZmlsbD0ibm9uZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIwOCAwLjgwMzcxMSkiLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K";
export { SvgImgFooterLineOld as ReactComponent };